const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const OPERATIONS_API = `${API_BASE_URL}/api/operations`;

async function operationsRequest(path, options = {}) {
  const response = await fetch(`${OPERATIONS_API}${path}`, {
    credentials: "include",
    cache: "no-store",
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.detail || data.error || `Request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }
  return data;
}

export async function getOperationsCsrf() {
  return operationsRequest("/csrf/");
}
async function operationsMutation(path, method = "PATCH", body) {
  const csrf = await getOperationsCsrf();
  return operationsRequest(path, {
    method,
    headers: {
      "X-CSRFToken": csrf.csrfToken,
      ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
}
export const operationsLogin = (slug, username, password) => operationsMutation(`/${encodeURIComponent(slug)}/login/`, "POST", { username, password });
export const startOperations2FAEnrollment = slug => operationsMutation(`/${encodeURIComponent(slug)}/2fa/enroll/start/`, "POST", {});
export const confirmOperations2FAEnrollment = (slug, token) => operationsMutation(`/${encodeURIComponent(slug)}/2fa/enroll/confirm/`, "POST", { token });
export const verifyOperations2FA = (slug, payload) => operationsMutation(`/${encodeURIComponent(slug)}/2fa/verify/`, "POST", payload);
export const getOperationsUser = slug => operationsRequest(`/${encodeURIComponent(slug)}/me/`);
export const operationsLogout = slug => operationsMutation(`/${encodeURIComponent(slug)}/logout/`, "POST");
export const getOperationsOrders = slug => operationsRequest(`/${encodeURIComponent(slug)}/orders/`);
export const approveOperationsOrder = (slug, orderId) => operationsMutation(`/${encodeURIComponent(slug)}/orders/${orderId}/approve/`);
export const confirmOperationsCash = (slug, orderId) => operationsMutation(`/${encodeURIComponent(slug)}/orders/${orderId}/confirm-cash/`);
export const getPendingCashPayments = slug => operationsRequest(`/${encodeURIComponent(slug)}/payments/pending/`);
export const collectOperationsCash = (slug, orderId) => operationsMutation(`/${encodeURIComponent(slug)}/orders/${orderId}/collect-cash/`);
export const getSuccessfulOperationsOrders = slug => operationsRequest(`/${encodeURIComponent(slug)}/orders/successful/`);
export const getFailedOnlineOperationsOrders = slug => operationsRequest(`/${encodeURIComponent(slug)}/orders/failed-online/`);
export const getOperationsTables = slug => operationsRequest(`/${encodeURIComponent(slug)}/tables/`);
export const getOperationsTable = (slug, tableId) => operationsRequest(`/${encodeURIComponent(slug)}/tables/${tableId}/`);
export const createOperationsTable = (slug, data) => operationsMutation(`/${encodeURIComponent(slug)}/tables/`, "POST", data);
export const updateOperationsTable = (slug, tableId, data) => operationsMutation(`/${encodeURIComponent(slug)}/tables/${tableId}/`, "PATCH", data);
export const openOperationsTableSession = (slug, tableId) => operationsMutation(`/${encodeURIComponent(slug)}/tables/${tableId}/open-session/`, "POST");
export const closeOperationsTableSession = (slug, tableId) => operationsMutation(`/${encodeURIComponent(slug)}/tables/${tableId}/close-session/`, "POST");
export const getParcelMenu = slug => operationsRequest(`/${encodeURIComponent(slug)}/parcel-orders/`);
export const createParcelOrder = (slug, items) => operationsMutation(`/${encodeURIComponent(slug)}/parcel-orders/`, "POST", { items });